import React from "react";
import { OverrideStringEditor } from "./OverrideStringEditor";
import type { OverrideStringEditorProps } from "./types";

export function OverrideStringEditorMenu(props: OverrideStringEditorProps) {
  return <OverrideStringEditor {...props} />;
}
